// extracted by mini-css-extract-plugin
export default {"cards":"KZLmGm1XaT"};